import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import { store } from '../../store/store';
import { Provider } from 'react-redux';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';
import SignatureModal from './SignatureModal';

loadDOMComponent({
	selector: 'react-signature',
	callback: ({ container, context, props }: any) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<SignatureModal userId={userId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
